module.exports = __webpack_public_path__ + "media/images/salespartner/bg-cta-right_sp-8e6bc02843cc0ffd65bb9b88f61fadc8.svg";